import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_TEXT_SUGGESTIONS } from '../delivery-note-correction.api';
import { TextSuggestion } from '../types/text-suggestion';

@Injectable()
export class TextSuggestionRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  list(usage: string): Promise<TextSuggestion[]> {
    return this.dataAccess.get<TextSuggestion[]>({
      path: SOFTLINE_API_TEXT_SUGGESTIONS,
      queryParams: { usage },
    });
  }
}
